import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button as MuiButton } from '@material-ui/core';

/**
 * 사용자는 Button을 통해 액션을 수행하고 탭을 전환할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
 */

const Button = styled(MuiButton)`
  min-width: 90px;
`;

Button.propTypes = {
  /** 버튼 라벨 */
  children: PropTypes.node.isRequired,
  /** 컴포넌트에 적용될 색상 */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /** 버튼 비활성화 여부 */
  disabled: PropTypes.bool,
  /** 버튼 사이즈 */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /** 변형 타입 */
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
};

Button.defaultProps = {
  color: 'default',
  disabled: false,
  size: 'medium',
  variant: 'text',
};

/** @component */
export default Button;
